import { render } from "./Companies.vue?vue&type=template&id=578b69b8"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"
script.render = render

export default script